/**
 * Enumération des modes disponibles à l'ouverture de l'application
 */
enum WorkingModeEnum {
	/** Tableau de bord principal (tout objet confondu) */
	MainDashboard = 0,
	/** Environnement de travail */
	Workbench = 1,
	/** Administration */
	Administration = 2,
	/** Système d'alertes */
	Alert = 3,
	/** Cartographie */
	Map = 4
}

export default WorkingModeEnum;